export default "__VITE_ASSET__DmVIpO86__"